import { createSelector } from 'reselect';

import { RootState } from 'app/store';

import { RequestStatus } from 'constants/enums';

export const selectJobseekers = (state: RootState) =>
  state.jobseekers.jobseekers;

export const selectIsJobseekersLoading = (state: RootState) =>
  state.jobseekers.status === RequestStatus.Loading;

export const selectJobseekersFacets = (state: RootState) =>
  state.jobseekers.facets;

export const selectJobseekersCount = (state: RootState) =>
  state.jobseekers.count;

export const selectJobseekersListMeta = (state: RootState) =>
  state.jobseekers.listMeta;

export const selectJobseekersDetails = (state: RootState) => {
  return state.jobseekers;
};

export const selectActiveUserId = (state: RootState) =>
  state.sidebar.activeUserId;

export const selectActiveJobseeker = createSelector(
  [selectJobseekers, selectActiveUserId],
  (jobseekers, activeUserId) =>
    jobseekers.find((jobseeker) => jobseeker.id === activeUserId)
);
